import _rb from "./rollbar.js";

const Errorr = {

    error: function(msg, data) {
//        Rollbar.error(msg, data);
        // do other processing here
        return data;
    }

};

export default Errorr;